<section class="page-container">
  <div class="flex min-w-0 items-center justify-between gap-4">
    <h1 class="main-heading min-w-0">
      <fa-icon [icon]="faCar" class="mr-1" />Finance Vehicle Receipt
    </h1>
    <app-navpath class="hidden md:block" />
  </div>

  <div class="content-container">
    <section>
      <h2 class="sub-heading w-full border-b">Search</h2>
      <div
        class="grid grid-cols-1 gap-x-10 gap-y-3 px-4 py-4 text-sm md:px-8 xl:grid-cols-2 xl:gap-y-2"
      >
        <div
          class="grid min-w-0 grid-cols-1 items-center gap-1 sm:grid-cols-[minmax(8rem,35%)_minmax(0,1fr)] sm:gap-3"
        >
          <label for="FinanceCompany" class="font-bold">Finance Company</label>
          <app-select-input
            [dataInput]="searchBooking[0].value"
            [selectOptions]="searchBooking[0].options || []"
            [required]="true"
            id="FinanceCompany"
            (dataOutput)="setSearchValue('FinanceCompany', $event); updateFieldsMainForm({ name: 'searchBooking', fields: searchBooking })"
            class="block min-w-0 w-full"
          />
        </div>
        <div
          class="grid min-w-0 grid-cols-1 items-center gap-1 sm:grid-cols-[minmax(8rem,35%)_minmax(0,1fr)] sm:gap-3"
        >
          <label for="searchInvoiceNumber" class="font-bold">Invoice Number</label>
          <div class="flex min-w-0">
            <app-search-input
              [dataInput]="searchBooking[1].value"
              [isButtonActive]="true"
              (dataOutput)="setSearchValue('searchInvoiceNumber', $event)"
              (clickSearch)="handleSearch({ fieldId: 'searchInvoiceNumber' })"
              id="searchInvoiceNumber"
              class="block min-w-0 flex-1"
            />
            <button
              type="button"
              class="flex shrink-0 items-center justify-center border border-l-0 border-gray-300 bg-gray-100 px-4 text-gray-700 hover:bg-gray-200"
              aria-label="Delete invoice"
              title="Delete invoice"
              [disabled]="deleting"
              (click)="deleteInvoice()"
            >
              <fa-icon [icon]="faTrash" />
            </button>
          </div>
        </div>
        <div
          class="grid min-w-0 grid-cols-1 items-center gap-1 sm:grid-cols-[minmax(8rem,35%)_minmax(0,1fr)] sm:gap-3"
        >
          <label for="searchContractNumber" class="font-bold">Contract Number</label>
          <app-search-input
            [dataInput]="searchBooking[2].value"
            [isButtonActive]="true"
            (dataOutput)="setSearchValue('searchContractNumber', $event)"
            (clickSearch)="handleSearch({ fieldId: 'searchContractNumber' })"
            id="searchContractNumber"
            class="block min-w-0 w-full"
          />
        </div>
        <div
          class="grid min-w-0 grid-cols-1 items-center gap-1 sm:grid-cols-[minmax(8rem,35%)_minmax(0,1fr)] sm:gap-3"
        >
          <label for="searchRegisterNumber" class="font-bold">Registration Number</label>
          <app-search-input
            [dataInput]="searchBooking[3].value"
            [isButtonActive]="true"
            (dataOutput)="setSearchValue('searchRegisterNumber', $event)"
            (clickSearch)="handleSearch({ fieldId: 'searchRegisterNumber' })"
            id="searchRegisterNumber"
            class="block min-w-0 w-full"
          />
        </div>
        <div
          class="grid min-w-0 grid-cols-1 items-center gap-1 sm:grid-cols-[minmax(8rem,35%)_minmax(0,1fr)] sm:gap-3"
        >
          <label for="searchBuyerName" class="font-bold">Buyer Name</label>
          <app-search-input
            [dataInput]="searchBooking[4].value"
            [isButtonActive]="true"
            (dataOutput)="setSearchValue('searchBuyerName', $event)"
            (clickSearch)="handleSearch({ fieldId: 'searchBuyerName' })"
            id="searchBuyerName"
            class="block min-w-0 w-full"
          />
        </div>
        <div
          class="grid min-w-0 grid-cols-1 items-center gap-1 sm:grid-cols-[minmax(8rem,35%)_minmax(0,1fr)] sm:gap-3"
        >
          <label for="searchReceiptNumber" class="font-bold">Receipt Number</label>
          <div class="flex min-w-0">
            <app-text-input
              dataType="text"
              [dataInput]="searchBooking[5].value"
              (dataOutput)="setSearchValue('searchReceiptNumber', $event)"
              id="searchReceiptNumber"
              class="block min-w-0 flex-1"
            />
            <button
              type="button"
              class="flex shrink-0 items-center justify-center border border-l-0 border-gray-300 bg-gray-100 px-4 text-gray-700 hover:bg-gray-200"
              aria-label="Print receipt"
              title="Print receipt"
              (click)="printExistingReceipt()"
            >
              <fa-icon [icon]="faPrint" />
            </button>
          </div>
        </div>
      </div>
    </section>

    <section class="mt-6">
      <h2 class="sub-heading w-full border-b">Details</h2>
      <app-data-form
        [dataFields]="buyersDetails"
        [dataName]="'buyersDetails'"
        [columns]="2"
        (updateFields_child)="updateFields($event)"
      />
    </section>
  </div>

  <div class="mt-4 flex w-full flex-col gap-1 sm:flex-row sm:flex-wrap">
    <button
      class="shorter-btn misc-btn"
      (click)="save()"
      [disabled]="saving || loadingReceipt || printReady || !showTrashTable"
    >
      <fa-icon [icon]="faFloppyDisk" class="mr-1" />Save
    </button>
    <button
      class="shorter-btn misc-btn"
      (click)="print()"
      [disabled]="!printReady"
    >
      <fa-icon [icon]="faPrint" class="mr-1" />Print New Receipt
    </button>
    <button class="shorter-btn clear-btn" (click)="clear()" [disabled]="saving">
      <fa-icon [icon]="faEraser" class="mr-1" />Clear
    </button>
    <button
      *ngIf="showCheckboxTable && hasSelectedEntries()"
      class="shorter-btn misc-btn"
      (click)="next()"
      [disabled]="loadingReceipt"
    >
      <fa-icon [icon]="faChain" class="mr-1" />Next
    </button>
  </div>

  <section
    *ngIf="loadingVehicles || tableInvoiceSelectionEntries.length || tableWithTrashEntries.length"
    class="content-container mt-4"
  >
    <h2 class="sub-heading w-full border-b">Listing Of All Unpaid Invoices</h2>
    <p *ngIf="loadingVehicles" class="my-3" role="status">
      Loading unpaid invoices…
    </p>
    <div class="w-full overflow-x-auto">
      <app-data-table
        *ngIf="showCheckboxTable && tableInvoiceSelectionEntries.length"
        class="block min-w-[52rem]"
        [tableHeaders]="tableHeadersWithCheckbox"
        [tableEntries]="tableInvoiceSelectionEntries"
      />
      <app-data-table
        *ngIf="showTrashTable && tableWithTrashEntries.length"
        class="block min-w-[52rem]"
        [tableHeaders]="tableHeadersWithTrash"
        [tableEntries]="tableWithTrashEntries"
        (remove)="removeSelectedEntry($event)"
      />
    </div>
  </section>
</section>
